import oAuthRequest from "./oauthRequest"


export const index = (page = 1) => {
  return oAuthRequest.get('/api/v1/io_credentials', { params: { page } })
}

export const destroy = (id) => {
  return oAuthRequest.delete(`/api/v1/io_credentials/${id}`)
}

export const show = (id) => {
  return oAuthRequest.get(`/api/v1/io_credentials/${id}`)
}


export const create = (body) => {
  return oAuthRequest.post(`/api/v1/io_credentials`, body)
}

export const update = (id, body) => {
  return oAuthRequest.put(`/api/v1/io_credentials/${id}`, body)
}

export const search = (query) => {
  return oAuthRequest.get('/api/v1/io_credentials', { params: { search: query } })
}